var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg20SettingsGear = function Svg20SettingsGear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.897 4.097c-.356-1.463-2.438-1.463-2.794 0a1.436 1.436 0 0 1-2.143.889c-1.286-.784-2.758.688-1.975 1.974.507.83.058 1.914-.887 2.144-1.464.355-1.464 2.438 0 2.792a1.436 1.436 0 0 1 .887 2.144c-.783 1.286.689 2.758 1.975 1.975a1.436 1.436 0 0 1 2.144.887c.355 1.464 2.438 1.464 2.792 0a1.436 1.436 0 0 1 2.144-.887c1.286.783 2.758-.689 1.975-1.975a1.437 1.437 0 0 1 .887-2.144c1.464-.355 1.464-2.437 0-2.792a1.436 1.436 0 0 1-.887-2.144c.783-1.286-.689-2.758-1.975-1.974a1.436 1.436 0 0 1-2.144-.888z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.167 10.5a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0"
  })));
};
export default Svg20SettingsGear;